import React from 'react'
import "./Order.css";
import moment from "moment";
import CheckoutProduct from "./CheckoutProduct";
import CurrencyFormat from "react-currency-format"
//upgrade firebase plan to blaze....
//install moment like npm install moment in the full app not the backend functions
// firebase deploy ---only functions this means deploy only the backend
// get api request after deployin the functions https://us-central1-challenge-
//comment out the localhost link in axios...and replace with the new api request link
//deploy app. 
//firebase init ...build folder as a public folder yes yes
// npm run build && firebase deploy --only hosting 

function Order({order}) {
    return (
        <div className="order">
            <h2>Order</h2>
            <p>{moment.unix(order.data.created)
            .format('MMMM Do YYYY, h:mma')}</p>
               <p className="order__id">
                      <small>{order.id}</small>  
               </p>
               {order.data.cart?.map(item=>{
                   <CheckoutProduct
                   id={item.id}
                   title={item.title}
                   image={item.image}
                   price={item.price}
                   rating={item.rating}   
                   hideButton
                   />
               })}

<CurrencyFormat
renderText={(value) =>{
    <>
    <h3 className="order__total">Order Total:{value}</h3>
    </>
}}

decimalScale={2}
value={order.data.amount / 100}
displayType={"text"}
thousandSeparator={true}
prefix={"$"}

/>


        </div>
    ) 
}

export default Order
